module.exports = __webpack_public_path__ + "img/11.364c4b52.png";